import "@babel/polyfill";
import $ from 'jquery';
import loader from './__modules/loader';
import video from "./__modules/video";
import faq from "./__modules/faq";
import header from "./__modules/header";
import locomotiveInit from "./__modules/locomotive";
import splitText from "./__modules/splitText";
import heroSection1 from "./__modules/heroSection1";
import heroSection2 from "./__modules/heroSection2";
import heroSection3 from "./__modules/heroSection3";
import heroSection4 from "./__modules/heroSection4";
import subscription from "./__modules/subcription";

document.addEventListener('DOMContentLoaded', () => {
	// loader();

	if($('.e-reveal').length) {
		splitText()
	}

	let scroll = locomotiveInit();

	if ($(".hero-section-1").length) {
		heroSection1();
	}

	if ($(".hero-section-2").length) {
		heroSection2();
	}

	if ($(".hero-section-3").length) {
		heroSection3();
	}

	if ($(".hero-section-4").length) {
		heroSection4();
	}

	// if($('.video').length) {
	// 	video();
	// }
	
	if($('.faq').length) {
		faq();
	}
	
	if($('.header').length) {
		header();
	}

	if($('.subscription').length) {
		subscription();
	}
});

window.addEventListener('load', () => {
});

window.addEventListener('resize', () => {
});

window.addEventListener('scroll', () => {
});